<ng-container *ngIf="carregando">
  <div class="loading-overlay">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>
</ng-container>

<router-outlet></router-outlet>
<p-toast></p-toast>